import React from "react";
import { FaCogs, FaCut, FaLayerGroup, FaLeaf, FaWarehouse } from "react-icons/fa";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import ImageBanner from "../../components/ImageBanner";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import ServiceStandardsSection from "../../components/service-page/ServiceStandardsSection";
import ServiceProcessSection from "../../components/service-page/ServiceProcessSection";
import ServiceIndustriesSection from "../../components/service-page/ServiceIndustriesSection";
import WhyChooseCarousel, {
  toWhyChooseReasons,
} from "../../components/WhyChooseCarousel";
import { homeIcons } from "../Home/homeIcons";
import "../../styles/brand.css";
import {
  finalCtaContent,
  heroContent,
  industriesContent,
  processContent,
  servicesContent,
  textileSeo,
  whyChooseContent,
} from "./textileContent";

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}${textileSeo.slug}`;

/* the shared registry covers textile, export and supply chain; the five
   textile-specific sectors this document names are kept local rather than
   widening a registry the whole site shares */
const industryIcons = {
  ...homeIcons,
  garment: FaCut,
  fabric: FaLayerGroup,
  spinning: FaCogs,
  processing: FaWarehouse,
  sustainableFashion: FaLeaf,
};

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: heroContent.h1,
    description: textileSeo.description,
    url: CANONICAL,
    serviceType: "Textile compliance and sustainability certification consultancy",
    provider: { "@type": "Organization", name: "MBA Solutions", url: SITE_URL },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: servicesContent.title,
      itemListElement: servicesContent.standards.map((standard) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: standard.title },
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: `${SITE_URL}/services`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Textile Compliance Services",
        item: CANONICAL,
      },
    ],
  },
];

const TextileComplianceServices = () => (
  <Layout
    title={textileSeo.title}
    description={textileSeo.description}
    keywords="textile compliance consultancy, GOTS certification, GRS certification, RCS, OCS, WRAP certification, Sedex SMETA audit, responsible manufacturing, MBA Solutions"
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="textile-page brand-page bg-white">
      {/* the supplied banner, shown whole — never cropped */}
      <ImageBanner
        src="/assets/banners/Textile-Compliance-Services.jpeg"
        alt="Textile Compliance Services — MBA Solutions"
        width={1708}
        height={624}
        whole
      />
      <PageIntro
        id="textile-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <ServiceStandardsSection
        id="textile-services-heading"
        title={servicesContent.title}
        standards={servicesContent.standards}
      />
      <ServiceProcessSection
        id="textile-process-heading"
        title={processContent.title}
        steps={processContent.steps}
      />
      <ServiceIndustriesSection
        id="textile-industries-heading"
        title={industriesContent.title}
        intro={industriesContent.intro}
        industries={industriesContent.industries}
        icons={industryIcons}
      />
      <WhyChooseCarousel
        id="textile-why-choose-heading"
        title={whyChooseContent.title}
        reasons={toWhyChooseReasons(whyChooseContent.reasons)}
        tone="light"
      />
      <FinalCtaPanel
        id="textile-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
);

export default TextileComplianceServices;
